<template>
  <span class="position-absolute top-0 end-100 translate-middle badge rounded-pill bg-danger" id="counterBasketTemp" style="transform: translate(-110%,-33%)!important;">
  </span>
</template>
<script setup>
</script>
<style scoped>

</style>